import React from "react";

const AdminPageContainer = ({ children }) => {
  return (
    <div className="py-2 px-1" >
      {children}
    </div>
  );
};

export default AdminPageContainer;
